// General Use
import myFirebase from "../firebase"

// Cloud Function Parsing to be used for changing accountType in Authentication.js
export const addGuideRole = myFirebase.functions().httpsCallable('addGuideRole')
export const addTier1Role = myFirebase.functions().httpsCallable('addTier1Role')
export const addTier2Role = myFirebase.functions().httpsCallable('addTier2Role')
export const addTier3Role = myFirebase.functions().httpsCallable('addTier3Role')